import React, { Component } from "react";
import { connect } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";

class ProductDescription extends Component {
  excludeEmptyTags(htmlString) {
    try {
      if (!htmlString) return true;
      htmlString = htmlString.replaceAll("&lt;br&gt;", "");
      htmlString = htmlString.replaceAll("&lt;/br&gt;", "");
      const tempElement = document.createElement("div");
      tempElement.innerHTML = htmlString;
      const emptyTags = tempElement.querySelectorAll(":empty");
      for (const emptyTag of emptyTags) {
        emptyTag.parentNode.removeChild(emptyTag);
      }
      const resultHtml = tempElement.innerHTML.trim();
      const onlyPTags = /^<p><\/p>+$/.test(resultHtml) || resultHtml == "";
      return onlyPTags;
    } catch {
      return true;
    }
  }

  render() {
    const { language, current_product, customTexts } = this.props;
    if (
      this.excludeEmptyTags(
        language == "english"
          ? current_product.description
          : current_product.ar_description
      )
    )
      return null;

    return (
      <>
        <div
          className={"mx-3 mt-4 ".concat(
            language == "english" ? "text-left" : "text-right"
          )}
          style={{ fontWeight: "bold" }}
        >
          {language === "arabic"
            ? customTexts.product_description_ar
            : customTexts.product_description}
        </div>
        <div className="mt-1 border " style={{ backgroundColor: "white" }}>
          {this.props.fodooleLoading ? (
            <CircularProgress
              size={20}
              style={{ marginTop: 5 }}
              className="my-3"
            />
          ) : (
            <div
              className={"mx-3 my-3 ".concat(
                language == "english" ? "text-left" : "text-right"
              )}
              id="description"
              dangerouslySetInnerHTML={{
                __html:
                  language === "arabic"
                    ? current_product.ar_description
                    : current_product.description,
              }}
              style={{ direction: language == "english" ? "ltr" : "rtl" }}
            ></div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    customTexts: state.store.store.settings.custom_texts,
  };
};
export default connect(mapStateToProps)(ProductDescription);
